import {FC, memo, useState} from 'react'
import {Stack} from 'react-bootstrap'
import ReactDatePicker from 'react-datepicker'
import {FaCalendar} from 'react-icons/fa'
import './DatePickerV2.scss'
import moment from 'moment'

const ICON_SIZE = 12

export interface DatePickerV2Props {
  startDate: string
  endDate?: string
  isSelectsRange?: boolean
  placeholder?: string
  isClearable?: boolean
  dateFormat?: string
  iconPosition?: 'left' | 'right'
  onChange: ({startDate, endDate}: {startDate: string; endDate: string}) => void
}

export const DatePickerV2: FC<DatePickerV2Props> = (props) => {
  const {startDate, endDate, isClearable, onChange} = props
  const [start, setStart] = useState<Date | null>(startDate ? new Date(startDate) : null)
  const [end, setEnd] = useState<Date | null>(endDate ? new Date(endDate) : null)

  const handleDateChange = (date: Date | null) => {
    setStart(date)
    onChange({
      startDate: !date ? '' : moment(date).format('yyyy-MM-DD'),
      endDate: !date ? '' : moment(date).format('yyyy-MM-DD'),
    })
  }

  const handleDateRangeChange = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates
    setStart(start)
    setEnd(end)
    onChange({
      startDate: !start ? '' : moment(start).format('yyyy/MM/DD'),
      endDate: !end ? '' : moment(end).format('yyyy/MM/DD'),
    })
  }

  return (
    <Stack
      direction='horizontal'
      gap={0}
      style={{
        border: '1.8px solid #d9dce4',
        background: 'white',
        borderRadius: 6,
        paddingLeft: 10,
      }}
    >
      {props.iconPosition === 'left' && (
        <div style={{width: 'auto'}}>
          <FaCalendar size={ICON_SIZE} color='gray' style={{padding: 0, marginRight: '8px'}} />
        </div>
      )}
      <div className='datepickerv2'>
        {!props.isSelectsRange ? (
          <ReactDatePicker
            placeholderText={props.placeholder}
            selected={start}
            dateFormat={props.dateFormat}
            isClearable={isClearable}
            onChange={handleDateChange}
          />
        ) : (
          <ReactDatePicker
            placeholderText={props.placeholder}
            selected={start}
            startDate={start}
            endDate={end}
            selectsRange
            isClearable={isClearable}
            dateFormat={props.dateFormat}
            onChange={handleDateRangeChange}
          />
        )}
      </div>
      {props.iconPosition === 'right' && (
        <div style={{width: 'auto'}}>
          <FaCalendar size={ICON_SIZE} color='gray' style={{marginRight: '0px'}} />
        </div>
      )}
    </Stack>
  )
}

DatePickerV2.defaultProps = {
  isSelectsRange: true,
  isClearable: true,
  placeholder: 'Date range',
  dateFormat: 'dd/MM/yyyy',
  iconPosition: 'left',
}

export default memo(DatePickerV2)
